export const config = {
    name: 'Sfx tag',
};
